var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrochetEtape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.071 8.917c1.235 1.264 1.211 3.29-0.053 4.525l-42.145 41.16c-1.237 1.208-3.21 1.215-4.456 0.015l-15.407-14.841c-1.273-1.226-1.311-3.252-0.085-4.525s3.252-1.311 4.525-0.084l13.172 12.687 39.925-38.991c1.264-1.235 3.29-1.211 4.525 0.054z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrochetEtape);
export default __webpack_public_path__ + "static/media/crochet-etape.4d0353640a99184e15898c5646c2867b.svg";
export { ForwardRef as ReactComponent };